var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},[_c('v-img',{attrs:{"src":require("@/assets/hero.svg"),"max-height":"650","contain":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }